import { render, staticRenderFns } from "./headFeeDetailPriceEachMonth.vue?vue&type=template&id=45f9793e&scoped=true&"
import script from "./headFeeDetailPriceEachMonth.vue?vue&type=script&lang=js&"
export * from "./headFeeDetailPriceEachMonth.vue?vue&type=script&lang=js&"
import style0 from "./headFeeDetailPriceEachMonth.vue?vue&type=style&index=0&id=45f9793e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f9793e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})
